import { Reveal } from "./Reveal";

const chapters = [
  {
    n: "01",
    title: "Grass first, always",
    body: "Open pasture and native grasses, with room to roam — never confined, never rushed, never a feedlot. That's the flavor foundation you can taste in every cut.",
  },
  {
    n: "02",
    title: "Natural grain finish",
    body: "Grass fed, then finished naturally on grain for the final 45 days on the same farm. That's where the marbling, buttery texture, and rich beefy finish come from.",
  },
  {
    n: "03",
    title: "The whole animal, nothing less",
    body: "We don't run a cut list. You buy a share of the animal — quarter, half, or whole — and our licensed butcher handles the harvest and every cut. Every steak, roast, and pound of grind is yours.",
  },
];

export const Manifesto = () => (
  <section id="standard" className="py-24 lg:py-32" data-testid="manifesto-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal>
        <p className="text-xs tracking-[0.25em] uppercase font-bold text-clay mb-4">Our Standard</p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium max-w-2xl leading-tight">
          Three promises, kept on every animal.
        </h2>
      </Reveal>

      <div className="mt-16 lg:mt-20 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8">
        {chapters.map((c, i) => (
          <Reveal
            key={c.n}
            delay={i * 0.12}
            className={`lg:col-span-4 ${i === 1 ? "lg:mt-16" : ""} ${i === 2 ? "lg:mt-32" : ""}`}
          >
            <div className="border-t-2 border-forest/15 pt-8" data-testid={`manifesto-chapter-${c.n}`}>
              <span className="font-display italic text-5xl text-clay/80">{c.n}</span>
              <h3 className="font-display text-xl sm:text-2xl tracking-tight font-medium mt-6">{c.title}</h3>
              <p className="text-moss text-base leading-relaxed mt-4">{c.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
